import React from "react";
import "./Login.css";
import {loginWithPKCE} from "./spotify";
import PoweredBy from "./Powered";

function Login() {
	// return (
	// 	<div className="login">
	// 		<img
	// 			src="https://prowly-uploads.s3.eu-west-1.amazonaws.com/uploads/1036/assets/56130/Spotify_Logo_CMYK_Green.png"
	// 			alt="spotify logo"
	// 		/>
	// 		<a href={loginUrl}>LOG IN</a>
	// 	</div>
	// );

	return (
		<div className={'login'}>
			{/*	loggout button */}
      {/*<img*/}
      {/*  src="https://prowly-uploads.s3.eu-west-1.amazonaws.com/uploads/1036/assets/56130/Spotify_Logo_CMYK_Green.png"*/}
      {/*  alt="spotify logo"*/}
      {/*/>*/}

      <button
        style={loginButtonStyle}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#f9fafb';
          e.target.style.color = '#374151';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#282828';
          e.target.style.color = '#eaeaea';
        }}
        onClick={loginWithPKCE}>
        Start
      </button>


      {/*<button*/}
			{/*	style={loginButtonStyle}*/}
			{/*	onMouseEnter={(e) => {*/}
			{/*		e.target.style.backgroundColor = '#f9fafb';*/}
			{/*		e.target.style.color = '#374151';*/}
			{/*	}}*/}
			{/*	onMouseLeave={(e) => {*/}
			{/*		e.target.style.backgroundColor = '#282828';*/}
			{/*		e.target.style.color = '#eaeaea';*/}
			{/*	}}*/}
			{/*>*/}
			{/*	<a style={linkStyle} href={loginUrl}>Start</a>*/}
			{/*</button>*/}

      <PoweredBy/>
		</div>
	)
}

export default Login;


const loginButtonStyle = {
	padding: '6px 16px',
	fontSize: '14px',
	fontWeight: '500',
	border: '1px solid #d1d5db',
	borderRadius: '4px',
	cursor: 'pointer',
	transition: 'all 0.15s ease',
	outline: 'none',
	fontFamily: 'inherit',
	backgroundColor: '#282828',
	// borderColor: '#eaeaea',
	color: '#eaeaea'
};

// remove deafult styles and inherit from button
const linkStyle = {
	textDecoration: 'none',
	color: 'inherit',
	fontFamily: 'inherit'
}